var $ = require("./lib/qsa");
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var filters = $.one("#filters");
var filterStatus = $.one("#filterStatus");
var reviews = $("#reviews .review");
var pymChild = null;

var onWindowLoaded = function() {
  pym.then(child => {
    pymChild = child;

    // shuffle programs
    shufflePrograms("reviews", "review");

    filters.addEventListener("input", filterContent);

    // check filters from parent URL
    var parentUrl = new URL(pymChild.parentUrl, location, true);
    var params = new URLSearchParams(parentUrl.search);
    var presetGenre = params.get("genre");
    var presetPlatform = params.get("platform");

    if (presetGenre) {
      var selector = $.one("#filters #genre_" + presetGenre);
      if (selector) {
        selector.click();
      }
    }

    if (presetPlatform) {
      var selector = $.one("#filters #platform_" + presetPlatform);
      if (selector) {
        selector.click();
      }
    }

    updateFilterStatus();

    pymChild.sendHeight();
    window.addEventListener("resize", () => pymChild.sendHeight());
  });
}

// shuffle the programs
// via https://stackoverflow.com/questions/43979555/javascript-shuffle-divs-within-div
var shufflePrograms = function(c, el) {
  var container = document.getElementById(c);
  var elements = Array.prototype.slice.call(container.getElementsByClassName(el));
  elements.forEach(function(element){
    container.removeChild(element);
  });
  shuffleArray(elements);
  elements.forEach(function(element){
    container.appendChild(element);
  })
}

function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
  return array;
}

var filterContent = function(evt) {
  // console.log("clicked: " + evt.target.value);

  // handle all vs. singular toggles
  [ "genre", "platform" ].forEach((section, i) => {
    if (evt.target.value == (section + "_all") && evt.target.checked) {
      document.querySelectorAll("#filters ." + section + " input[type=checkbox]:checked").forEach((item, i) => {
        if (item.value != (section + "_all")) {
          item.checked = false;
        }
      });
    } else if (evt.target.value == (section + "_all") && !evt.target.checked) {
      // don't allow the "all filters to become unchecked if they're the only ones"
      document.querySelector("#filters #" + section + "_all").checked = true;
    } else if (evt.target.value.includes(section + "_")) {
      // untoggle "all" if you use a sub-filter
      document.querySelector("#filters #" + section + "_all").checked = false;
    }
  });

  // compile all the currently-selected filters
  var checkFilters = function(section) {
    return $(
      "#filters ." + section + " input[type=checkbox]:checked",
      filters
    ).map((el) => el.getAttribute("value"));
  }

  var genreFiltersChecked = checkFilters("genre");
  // if no filters are selected, go back to "all"
  if (genreFiltersChecked.length == 0) {
    document.querySelector("#filters #genre_all").checked = true;
    genreFiltersChecked = checkFilters("genre");
  }

  var platformFiltersChecked = checkFilters("platform");
  // if no filters are selected, go back to "all"
  if (platformFiltersChecked.length == 0) {
    document.querySelector("#filters #platform_all").checked = true;
    platformFiltersChecked = checkFilters("platform");
  }
  // console.log(genreFiltersChecked, platformFiltersChecked);

  // show/hide reviews
  var matchingReviews = 0;
  reviews.forEach((review, i) => {
    var hasGenre = false;
    var hasPlatform = false;

    // match against genres
    // thank you: https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_intersection
    if (genreFiltersChecked.includes("genre_all")) {
      hasGenre = true;
    } else {
      var genreTest = [ genreFiltersChecked, [...review.classList] ];
      genreTest = genreTest.reduce(function(a,b) {
        return a.filter(function(value) {
          return b.includes(value);
        });
      });
      if (genreTest.length > 0) {
        hasGenre = true;
      }
    }

    // match against platforms
    if (platformFiltersChecked.includes("platform_all")) {
      hasPlatform = true;
    } else {
      var platformTest = [ platformFiltersChecked, [...review.classList] ];
      platformTest = platformTest.reduce(function(a,b) {
        return a.filter(function(value) {
          return b.includes(value);
        });
      });
      if (platformTest.length > 0) {
        hasPlatform = true;
      }
    }

    // if genre and platform match, show it
    if (hasGenre && hasPlatform) {
      review.classList.remove("hidden");
      matchingReviews++;
    } else {
      review.classList.add("hidden");
    }
  });

  updateFilterStatus(matchingReviews);

  pymChild.sendHeight();
}

var updateFilterStatus = function() {
  var activeCount = $(".review:not(.hidden)").length;
  var statusMsg = "";
  switch(activeCount) {
    case 0:
      statusMsg = "No games found.";
      break;
    case 1:
      statusMsg = "1 game found.";
      break;
    default:
      statusMsg = activeCount + " games found.";
      break;
  }
  filterStatus.innerHTML = statusMsg;
}

// wait for images to load
window.onload = onWindowLoaded;
